"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stencilFontProperties = exports.STENCIL_FONT_CDN_URL = exports.FONTFACE_CHECK_FONT_SIZE = void 0;
const AMAZON_EMBER = 'Amazon Ember';
const AMAZON_EMBER_MONO = 'Amazon Ember Mono';
const STENCIL_FONT_CDN_URL = exports.STENCIL_FONT_CDN_URL = 'https://assets.stencil.a2z.com/fonts';
const FONTFACE_CHECK_FONT_SIZE = exports.FONTFACE_CHECK_FONT_SIZE = '12px';
const stencilFontProperties = exports.stencilFontProperties = [{
  fontFamily: AMAZON_EMBER,
  filename: 'AmazonEmber_W_Rg.woff2',
  fontDisplay: 'swap'
}, {
  fontFamily: AMAZON_EMBER,
  fontStyle: 'italic',
  filename: 'AmazonEmber_W_RgIt.woff2',
  fontDisplay: 'swap'
}, {
  fontFamily: AMAZON_EMBER,
  fontWeight: 400,
  filename: 'AmazonEmber_W_Rg.woff2',
  fontDisplay: 'swap'
}, {
  fontFamily: AMAZON_EMBER,
  fontWeight: 400,
  fontStyle: 'italic',
  filename: 'AmazonEmber_W_RgIt.woff2',
  fontDisplay: 'swap'
}, {
  fontFamily: AMAZON_EMBER,
  fontWeight: 500,
  filename: 'AmazonEmber_W_Md.woff2',
  fontDisplay: 'swap'
}, {
  fontFamily: AMAZON_EMBER,
  fontWeight: 500,
  fontStyle: 'italic',
  filename: 'AmazonEmber_W_MdIt.woff2',
  fontDisplay: 'swap'
}, {
  fontFamily: AMAZON_EMBER,
  fontWeight: 700,
  filename: 'AmazonEmber_W_Bd.woff2',
  fontDisplay: 'swap'
}, {
  fontFamily: AMAZON_EMBER,
  fontWeight: 700,
  fontStyle: 'italic',
  filename: 'AmazonEmber_W_BdIt.woff2',
  fontDisplay: 'swap'
}, {
  fontFamily: AMAZON_EMBER_MONO,
  filename: 'AmazonEmberMono_W_Rg.woff2',
  fontDisplay: 'swap'
}, {
  fontFamily: AMAZON_EMBER_MONO,
  fontWeight: 700,
  filename: 'AmazonEmberMono_W_Bd.woff2',
  fontDisplay: 'swap'
}];